import React from 'react'
import { observer } from 'mobx-react-lite'
import AuthContainer from 'components/AuthContainer'
import SiteLayout from 'components/SiteLayout'
import Head from 'components/Head'
import FavoritesFeed from 'components/FavoritesFeed'
import FavoritesPageActionPrompt from 'components/FavoritesPageActionPrompt'
import StoriesStore from 'stores/stories'
import { useStore, usePagination, useUserId, useFeedPageView } from 'hooks'
import { getStaticWrapper } from 'utils'

const MyFeedPage = () => {
  const storiesStore = useStore(StoriesStore, { items: [] })
  const userId = useUserId()
  const pagination = usePagination(storiesStore.items, (query) => storiesStore.findNextFavorites(userId, query))
  useFeedPageView(pagination)

  const adSettings = {
    slot: 'section',
    revContentSlot: 'Feed',
    keyValues: {}
  }
  return (
    <SiteLayout adSettings={adSettings}>
      <Head
        title='Barstool Sports'
        description='Barstool Sports is a sports & pop culture blog covering the latest news and viral highlights of each and everyday with blogs, videos and podcasts.  By the common man, for the common man.'
      />
      <AuthContainer postAuthRedirect='/favorites' render={() => <FavoritesPageActionPrompt type='signin' />}>
        <FavoritesFeed {...pagination} adSettings={adSettings} />
      </AuthContainer>
    </SiteLayout>
  )
}

export const getStaticProps = getStaticWrapper()

export default observer(MyFeedPage)
